import { useRef, useState } from 'react';

import type {
  CampaignDetailTab,
  CreatorFilterOption,
  CreatorTabFilterRequest,
  PostFilterOption,
  PostTabFilterRequest,
} from './campaign-detail-state-types';

export function useCampaignDetailPageState() {
  const [activeTab, setActiveTab] = useState<CampaignDetailTab>('overview');
  const requestIdRef = useRef(0);
  const [creatorTabFilterRequest, setCreatorTabFilterRequest] =
    useState<CreatorTabFilterRequest | null>(null);
  const [postTabFilterRequest, setPostTabFilterRequest] = useState<PostTabFilterRequest | null>(
    null,
  );

  const nextRequestId = () => {
    requestIdRef.current += 1;
    return requestIdRef.current;
  };

  const openCreatorTab = (filter?: CreatorFilterOption) => {
    if (filter) {
      setCreatorTabFilterRequest({
        filter,
        requestId: nextRequestId(),
      });
    }

    setActiveTab('creator');
  };

  const openPostTab = (filter?: PostFilterOption) => {
    if (filter) {
      setPostTabFilterRequest({
        filter,
        requestId: nextRequestId(),
      });
    }

    setActiveTab('post');
  };

  return {
    activeTab,
    creatorTabFilterRequest,
    openCreatorTab,
    openPostTab,
    postTabFilterRequest,
    setActiveTab,
  };
}
